export default __webpack_public_path__ + "static/Visa-Debit-Card-Product-Sheet-Oxygen-544e10e9029d6b4995545b350353753b.pdf";